<template>
  <div>
    <div class="container" v-loading="isLoading">
      <div class="row justify-content-between">
        <div class="px-2">
          <el-form
            ref="queryForm"
            :model="queryForm"
            label-width="100px"
            :inline="true"
            @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
          >
            <el-form-item label="錄音流通" label-width="100px">
              <el-select
                v-model="queryForm.recshare"
                size="small"
                class="selectqry"
                filterable
              >
                <el-option
                  v-for="item in myRecshares"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                size="small"
                v-model="queryForm.qstr"
                placeholder="訂閱者、頻道名稱、檔名"
                style="width:180px"
              ></el-input>
            </el-form-item>

            <!--<el-form-item label="顏色">-->
            <!--<el-checkbox-group v-model="queryForm.colors">-->
            <!--<el-checkbox-->
            <!--v-for="itemColor in tagColorList"-->
            <!--:key="itemColor.value"-->
            <!--:label="itemColor.value"-->
            <!--:style="{ color: itemColor.txtColor }" >-->
            <!--{{ itemColor.txtLabel }}</el-checkbox >-->
            <!--</el-checkbox-group>-->
            <!--</el-form-item>-->

            <el-form-item label=" " label-width="15px">
              <el-radio
                v-model="statusRadio"
                label="toApprove"
                class="radioItem"
                >待審核</el-radio
              >
              <el-radio v-model="statusRadio" label="all" class="radioItem"
                >全部</el-radio
              >
            </el-form-item>

            <!--<el-form-item>-->
            <el-form-item label=" " label-width="15px">
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="funcpanel">
          <el-button
            type="primary"
            @click="handleBatchApprove"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次核准</el-button
          >

          <el-button
            type="danger"
            @click="handleBatchReject"
            size="small"
            :disabled="selectedRow.length === 0"
            >批次拒絕</el-button
          >
        </div>
      </div>
    </div>

    <CCard>
      <CCardHeader>
        <CIcon name="cil-library-building" /> 部門：{{
          getRecshareName(activeQueryForm.recshare)
        }}
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            :data="approvals"
            v-loading="isLoading"
            ref="dataTable"
            @sort-change="sortChange"
            @selection-change="handleSelectionChange"
            :default-sort="{ prop: defaultSortCol, order: defaultOrder }"
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="45"> </el-table-column>

            <el-table-column
              type="index"
              :index="indexFormatter"
              prop="id"
              fixed
            >
            </el-table-column>

            <el-table-column
              label="錄音流通"
              prop="recshare.name"
              sortable="custom"
              width="150"
            >
              <template #default="scope">
                <el-tag :style="getTagStyle(scope.row.recshare.color)">{{
                  scope.row.recshare.name
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column
              label="檔名"
              prop="asset.name"
              sortable="custom"
              width="160"
            >
            </el-table-column>

            <el-table-column
              label="狀態"
              prop="isApproved"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                <span v-if="isStatusApproved(scope.row)">
                  <img
                    src="./../assets/icons/success.svg"
                    class="successicon"
                  />
                  核准
                </span>
                <span v-else-if="isStatusRejected(scope.row)">
                  <img src="./../assets/icons/reject.svg" class="rejecticon" />
                  拒絕
                </span>
                <span v-else class="ml-3">
                  待審核
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="備註"
              prop="asset.description"
              width="200"
            >
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="singleChangeApprStatus(true, scope.row, scope.$index)"
                  :disabled="isStatusApproved(scope.row) || isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  >核准
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="
                    singleChangeApprStatus(false, scope.row, scope.$index)
                  "
                  :disabled="isStatusRejected(scope.row) || isSwitchDisabled(scope.$index)"
                  v-loading="isSwitchDisabled(scope.$index)"
                  >拒絕
                </el-button>

                <el-button
                  v-if="isAssetPlayable(scope.row.asset)"
                  size="mini"
                  @click="playAsset(scope.row)"
                  >播放
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </CRow>
        <CRow>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </CRow>

        <PlayerDlg
          v-model="isPlayDlgVisible"
          :assetName="selAssetName"
          :selectedItemId="selectedItemId"
          :key="`play_${playDlgKey}`"
        ></PlayerDlg>

        <EditOrgWhitelistDlg
          v-model="isDlgVisible"
          :channelName="getRecshareName(activeQueryForm.recshare)"
          :channelId="activeQueryForm.recshare"
          :key="dlgKey"
        ></EditOrgWhitelistDlg>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import appConfig from "@/appConfig";
import EditOrgWhitelistDlg from "@/components/gblchnl/EditOrgWhitelistDlg";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import PlayerDlg from "@/components/channel/PlayerDlg";
import API from "@/api/";
export default {
  mixins: [tagColorsMixin],
  components: {
    EditOrgWhitelistDlg,
    PlayerDlg,
  },

  created() {
    this.sort = this.defaultSortCol;
    this.order = this.defaultOrder;
    API.my.recshares().then(res => {
      this.myRecshares = res.data;
      if (res.data.length) {
        this.queryForm.recshare = res.data[0].id;
        this.activeQueryForm.recshare = res.data[0].id;

        this.query(
          this.pageSize,
          0,
          this.sort,
          this.order,
          this.activeQueryForm
        );
      }
    });
  },

  data() {
    return {
      approvals: [],
      total: 0,
      offset: 0,
      sort: "id",
      order: "descending",

      statusRadio: "toApprove",
      selectedRow: [],
      isLoading: false,
      disabledSwitchIdx: [],
      defaultSortCol: "recshare.name",
      defaultOrder: "descending",
      myRecshares: [],
      dlgKey: 0,
      playDlgKey: 0,
      isDlgVisible: false,
      isPlayDlgVisible: false,
      selAssetName: "",
      selectedItemId: null,
      pageSize: 50,
      currentPage: 1,
      queryForm: {
        recshare: undefined,
        qstr: "",
        //colors: [],
      },
      activeQueryForm: {
        recshare: undefined,
        qstr: "",
        todo: 1,
        //colors: [],
      },
    };
  },
  methods: {
    playAsset(item) {
      this.selectedItemId = item.asset.idd;
      this.selAssetName = item.asset.name;
      this.playDlgKey = this.playDlgKey ? 0 : 1;
      this.isPlayDlgVisible = true;
    },
    isFilePlayable(fileName) {
      const playableExt = appConfig.PLAYABLE_EXT;
      const ext =
        fileName.indexOf(".") > -1
          ? fileName
              .split(".")
              .pop()
              .toLowerCase()
          : "";
      return playableExt.some(item => item === ext);
    },
    isAssetPlayable(item) {
      return this.isFilePlayable(item.name);
    },
    batchHandler(isSkipped, actionFunc, successMsg) {
      let promises = [];
      this.isLoading = true;
      let runningItem = [];
      let failedItem = [];
      this.selectedRow.forEach(row => {
        if (!isSkipped(row)) {
          runningItem.push(row);
          promises.push(actionFunc(row));
        }
      });

      this.$refs.dataTable.clearSelection();
      Promise.allSettled(promises)
        .then(results => {
          results.forEach((res, idx) => {
            //if (res.status === "fulfilled") {
            //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], false);
            //}
            if (res.status === "rejected") {
              //console.log(`rejected: pushed name = ${runningItem[idx].name}`);
              failedItem.push({
                id: runningItem[idx].id,
                type: runningItem[idx].type,
              });
              //this.$refs.dataTable.toggleRowSelection(this.members[selectedIdx[idx]], true);
            }
          });

          //console.log(`failedItem = ${JSON.stringify(failedItem)}`);
          if (!failedItem.length) {
            this.$message.success(successMsg);
          } else {
            this.$message.error("部分項目發生錯誤!");
          }
        })
        .finally(() => {
          //NOTE: no new query after batch processing
          failedItem.forEach(fItem => {
            const failedOne = this.approvals.find(
              item => item.id === fItem.id && item.type === fItem.type
            );
            failedOne &&
              this.$refs.dataTable.toggleRowSelection(failedOne, true);
          });

          this.isLoading = false;
        });
    },

    getApprIdx(row) {
      return this.approvals.findIndex(
        appr => appr.id === row.id && appr.type === row.type
      );
    },

    handleBatchApprove() {
      const isSkipped = row => (this.isStatusApproved(row) ? true : false);
      const actCallback = row =>
        this.setApprStatus(true, row, this.getApprIdx(row), true, false);
      this.batchHandler(isSkipped, actCallback, "批次核准成功");
    },

    handleBatchReject() {
      const isSkipped = row => (this.isStatusRejected(row) ? true : false);
      const actCallback = row =>
        this.setApprStatus(false, row, this.getApprIdx(row), true, false);
      this.batchHandler(isSkipped, actCallback, "批次拒絕成功");
    },

    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },

    isSwitchDisabled(idx) {
      return this.disabledSwitchIdx.includes(idx);
    },

    getRecshareName(recshareId) {
      const foundRecshare = this.myRecshares.find(recshare => recshare.id === recshareId);
      return foundRecshare ? foundRecshare.name : "";
    },

    handleQueryClick(queryForm) {
      this.currentPage = 1; //reset pagination to the first page
      this.activeQueryForm = { ...queryForm };
      if (this.statusRadio === "toApprove") {
        this.activeQueryForm.todo = 1;
      } else {
        delete this.activeQueryForm.todo;
      }
      this.isLoading = true;
      this.query(
        this.pageSize,
        0,
        this.sort,
        this.order,
        this.activeQueryForm
      ).then(() => (this.isLoading = false));
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.query(val, this.offset, this.sort, this.order, this.activeQueryForm);
    },

    handleCurrentChange(page) {
      this.query(
        this.pageSize,
        this.pageSize * (page - 1),
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },

    query(max, offset, sort, order, params) {
      const newParams = {
        max: max,
        offset: offset,
        sort,
        order,
        ...params,
      };

      return API.recshareAppr.list(newParams).then(res => {
        if (res.status === 200) {
          this.approvals = res.data[0];
          this.total = res.data[1];
          this.offset = offset;
          return res;
        } else {
          return Promise.reject(res);
        }
      });
    },

    indexFormatter(index) {
      return `#${parseInt(this.offset) + index + 1}`;
    },

    singleChangeApprStatus(isApproved, apprItem, index) {
      //console.log( `singleChangeApprStatus: isApproved=${isApproved}, index=${index}}`);
      const isChecked = this.selectedRow.find(row => row.id === apprItem.id);
      let p;
      this.disabledSwitchIdx.push(index);
      p = this.setApprStatus(isApproved, apprItem, index, true, true);
      p.finally(() => {
        isChecked &&
          this.$refs.dataTable.toggleRowSelection(this.approvals[index], true);

        const found = this.disabledSwitchIdx.indexOf(index);
        found !== -1 && this.disabledSwitchIdx.splice(found, 1);
      });
    },

    setApprStatus(
      isApproved,
      apprItem,
      index,
      updateStore = true,
      showMsg = true
    ) {
      const params = { isApproved: isApproved };
      let p;

      p = API.recshareAppr.setSubsAppr(apprItem.id, params);

      return p.then(() => {
        if (updateStore) {
          this.approvals[index].isApproved = isApproved ? true : false;
        }

        showMsg &&
          this.$message({
            type: "success",
            message: "審核成功!",
          });
      });
    },

    isStatusApproved(apprItem) {
      return apprItem.isApproved === true;
    },

    isStatusRejected(apprItem) {
      return apprItem.isApproved === false;
    },

    sortChange(args) {
      if (args.order === null) {
        this.sort = this.defaultSortCol;
        this.order = this.defaultOrder;
      } else {
        this.sort = args.prop;
        this.order = args.order;
      }
      this.query(
        this.pageSize,
        this.offset,
        this.sort,
        this.order,
        this.activeQueryForm
      );
    },
  },
  computed: {},
};
</script>

<style scoped>
.radioItem {
  width: 50px;
}
.personicon {
  width: 24px;
  height: 24px;
  margin-left: 2px;
  margin-right: 2px;
}
.groupicon {
  width: 28px;
  height: 28px;
  margin-left: 0px;
  margin-right: 2px;
}
.successicon {
  width: 20px;
  height: 20px;
  margin-left: 2px;
  margin-right: 2px;
}
.rejecticon {
  width: 20px;
  height: 20px;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
